import React from "react";
import { FaUtensils } from "react-icons/fa";

function SplashScreen() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-100 z-50">
      <FaUtensils className="text-black-500 text-6xl mb-4 animate-bounce" />
      <p className="text-lg font-semibold text-gray-700">Ładowanie...</p>
    </div>
  );
}

export default SplashScreen;
